











import { Component, Vue, Watch } from "vue-property-decorator";
import { authModule, surveysModule } from "@/store";
import HolderSurvey from "../holder-assembly/HolderSurvey.vue";
import Loader from "@/components/ui/Loader.vue";
import { Survey } from "@/store/surveys/survey";
import { AuthStatus } from "@/store/auth/auth-status.enum";

@Component({
  components: { Loader, HolderSurvey },
})
export default class DashboardSurveys extends Vue {
  get loading(): boolean {
    return surveysModule.fetching;
  }

  get lastSurvey(): Survey {
    return surveysModule.lastSurvey;
  }

  get isFullyAuthenticated(): boolean {
    return authModule.authStatus === AuthStatus.Full;
  }

  async mounted(): Promise<void> {
    await this.fetch();
  }

  async fetch(): Promise<void> {
    try {
      await surveysModule.fetchAll();
    } catch (e) {
      // silent
    }
  }

  @Watch("isFullyAuthenticated")
  onAuthChanged() {
    this.fetch();
  }
}
